import React from 'react';

import {
    PrimaryButton,
    DarkButton,
} from '@acko-tech/building-blocks.ui.button';

import * as Styles from './styles';

interface BottomFixedCTAProps {
    ctaName: React.ReactElement | React.ReactElement[] | string;
    webFixed?: boolean;
    mobFixed?: boolean;
    margin?: string;
    mMargin?: string;
    width?: string;
    mWidth?: string;
    size?: 'large' | 'medium' | 'small' | 'extra-small';
    loading?: boolean;
    disabled?: boolean;
    background?: string;
    topElement?: React.ReactElement | React.ReactElement[] | string;
    bottomElement?: React.ReactElement | React.ReactElement[] | string;
    onClick?: (arg?: any) => void;
    type?: 'primary' | 'dark';
    shadow?: boolean;
}

export default function BottomFixedCTA(props: BottomFixedCTAProps) {
    const {
        webFixed = false,
        mobFixed = true,
        ctaName,
        margin,
        mMargin,
        size,
        width,
        mWidth,
        loading,
        disabled,
        topElement,
        bottomElement,
        onClick,
        background,
        type = 'primary',
        shadow = false,
    } = props;

    const CustomButton = type === 'primary' ? PrimaryButton : DarkButton;
    return (
        <Styles.Wrapper
            webFixed={webFixed}
            mobFixed={mobFixed}
            margin={margin}
            width={width}
            mWidth={mWidth}
            background={background}
            shadow={shadow}
        >
            {topElement}
            <Styles.CTAWrapper mMargin={mMargin}>
                <CustomButton
                    size={size}
                    loading={loading}
                    disabled={disabled}
                    onClick={onClick}
                >
                    <Styles.ButtonTextWrapper>
                        {ctaName}
                    </Styles.ButtonTextWrapper>
                </CustomButton>
            </Styles.CTAWrapper>
            {bottomElement}
        </Styles.Wrapper>
    );
}
